import React from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import CustomizableWidget from './CustomizableWidget';

const DraggableWidgetGrid = ({ 
  widgets, 
  onReorder, 
  onRemove, 
  onSettingsChange,
  availableMetrics 
}) => {
  const handleDragEnd = (result) => {
    if (!result.destination) return;
    
    onReorder(result.source.index, result.destination.index);
  };

  const getColSize = (size) => {
    switch (size) {
      case 'small': return { xs: 24, sm: 12, lg: 8 };
      case 'medium': return { xs: 24, sm: 12, lg: 12 };
      case 'large': return { xs: 24, sm: 24, lg: 16 };
      case 'full': return { xs: 24, sm: 24, lg: 24 };
      default: return { xs: 24, sm: 12, lg: 12 };
    }
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="widgets" direction="horizontal">
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '16px',
              background: snapshot.isDraggingOver ? '#f0f0f0' : 'transparent',
              padding: snapshot.isDraggingOver ? '8px' : '0',
              borderRadius: '8px',
              transition: 'all 0.2s ease'
            }}
          >
            {widgets.map((widget, index) => (
              <Draggable key={widget.id} draggableId={widget.id} index={index}>
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    {...provided.draggableProps}
                    style={{
                      ...provided.draggableProps.style,
                      opacity: snapshot.isDragging ? 0.8 : 1,
                      transform: snapshot.isDragging 
                        ? `${provided.draggableProps.style?.transform} rotate(2deg)` 
                        : provided.draggableProps.style?.transform,
                      transition: 'all 0.2s ease',
                      gridColumn: widget.settings.size === 'full' ? '1 / -1' : 
                                 widget.settings.size === 'large' ? 'span 2' : 'span 1'
                    }}
                  >
                    <div {...provided.dragHandleProps} style={{ cursor: 'move' }}>
                      <CustomizableWidget
                        title={widget.title}
                        widgetKey={widget.id}
                        onRemove={onRemove}
                        onSettingsChange={onSettingsChange}
                        availableMetrics={availableMetrics}
                        settings={widget.settings}
                      >
                        {widget.component()}
                      </CustomizableWidget>
                    </div>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
};

export default DraggableWidgetGrid;